import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Sections/Hero';
import ServicesGrid from '../components/Sections/ServicesGrid';
import ProjectShowcase from '../components/Sections/ProjectShowcase';

const Home = () => {
    return (
        <div className="home-page">
            {/* Sección Hero */}
            <Hero />

            {/* Sección Servicios Destacados */}
            <section className="section">
                <div className="container">
                    <h2 className="section-title">
                        <span className="neon-text">// SERVICIOS_PRINCIPALES</span>
                    </h2>
                    <ServicesGrid limit={3} />
                    <div className="text-center">
                        <Link to="/services" className="cyber-button magenta">
                            VER TODOS LOS SERVICIOS
                        </Link>
                    </div>
                </div>
            </section>

            {/* Sección Proyectos Destacados */}
            <section className="section">
                <div className="container">
                    <h2 className="section-title">
                        <span className="neon-text">// PROYECTOS_RECIENTES</span>
                    </h2>
                    <ProjectShowcase limit={3} />
                    <div className="text-center">
                        <Link to="/portfolio" className="cyber-button">
                            EXPLORAR PORTAFOLIO
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Home;